export default {
  formKey: String,
  mandatory: Boolean,
  autoFocus: Boolean,
  hideError: Boolean,
  noForm: Boolean,
  disabled: Boolean,
};
